document.addEventListener("scroll", (e) => {
  try {
    const headSection = document.getElementById("shopify-section-header") || {};
    const headerProcessEl = headSection?.getElementsByClassName(
      "header-process"
    )[0] || {
      style: {},
    };
    let containerHeight =
      document.getElementsByClassName("article-template")?.[0]?.clientHeight ||
      1;
    let processEl = document.getElementsByClassName("article-process")[0] || {
      style: {},
    };
    let processNumber =
      (window.scrollY / (containerHeight - window.innerHeight)) * 100;
    processEl.style.width = processNumber + "%";

    headerProcessEl.style.top = headSection?.clientHeight - 1 + "px";
    headerProcessEl.style.width = processNumber + "%";
  } catch (error) {
    console.error("顶部显示页面进度错误");
  }
});
